import { ComponentQrcodePainsItems, Qrcode } from '@/typings/types';
import { SectionTitle } from '@/common/titles';
import { TextRenderer } from '@/common/utils/textRenderer';
import ProductsList from '@/components/qrcode/products';
import Others from '@/components/qrcode/others';
import SlideUp from '@/common/utils/slideUp';

type PainsProps = {
  pains: Qrcode['pains'];
  brioches: Qrcode['brioches'];
  painepices: Qrcode['painepices'];
  ballotins: Qrcode['ballotins'];
};

const Pains = ({ pains, brioches, painepices, ballotins }: PainsProps) => {
  const { title, introduction, items } = pains ?? {};

  console.log(title);

  return (
    <section className={'flex flex-col justify-start max-w-6xl mt-16 lg:mt-0 mb-20'}>
      {title && <SectionTitle title={title} />}
      <SlideUp delay delayDuration={100} yOffset={25} className={'lg:w-10/12 mb-5'}>
        {introduction && <TextRenderer text={introduction} as={'div'} />}
      </SlideUp>
      <div className={'flex flex-col mb-20 lg:mb-16'}>
        <ProductsList items={items as ComponentQrcodePainsItems[]} />
      </div>
      <Others others={brioches} />
      <Others others={painepices} />
      <Others others={ballotins} />
    </section>
  );
};

export default Pains;
